import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../components/grid";
import { getPurchaseOrders, unrecordedOrders, billingItemsClocks, } from "../../../store/actions";
//import EditUser from "./edit"
import AddOrder from "./add"
import AddIcon from '../../../assets/images/ionic-ios-add-circle-outline.png';
import { format } from 'date-fns';
class PurchaseOrdersView extends Component {

  state = {
    loading: false,
    selectedRowData: "",
    isShow: false,
    showSideBar: false,
    columnDefs: [

      {
        headerName: "Order ID",
        field: "orderSystemId",
        width: 110,
        filter: false,
      },
      {
        headerName: "Order Date",
        field: "orderDate",
        resizable: true,
        width: 200,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
      },
      {
        headerName: "Invoiced On",
        field: "invoiceDate",
        resizable: true,
        width: 200,
        filter: false,
        valueFormatter: params => params.value ? format(new Date(params.value), 'MMM dd yyyy') : "",
      },
      {
        headerName: "Total Price",
        field: "totalPrice",
        resizable: true,
        width: 150,
        filter: false,
      },
      {
        headerName: "No. of Items",
        field: "qty",
        resizable: true,
        width: 100,
        filter: false,
      }
    ],
    rowData: [],
    searchText: '',
  };

  async componentDidMount() {
    await this.props.unrecordedOrders();
    await this.props.billingItemsClocks();
  };
  payload = {};
  onGridReady = params => {
    params.api.addGlobalListener((type, e) => {
      if (type === "rowClicked") {
        this.viewOrder(e.data);
      }
    })
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    let dataSource = {
      getRows: async (params) => {
        this.gridApi.showLoadingOverlay();
        await this.props.getPurchaseOrders(this.payload);
        const orders = this.props.PURCHASE_ORDERS;

        this.gridApi.hideOverlay();
        if (!orders?.records?.length) {
          this.gridApi.showNoRowsOverlay();
        } else {
          orders.records = orders.records.map(ord => ({ ...ord, qty: ord.inventoryItems.length }));
          this.setState({ rowData: orders.records });
          return params.successCallback(orders.records, orders.count);
        }
      }
    }
    params.api.setDatasource(dataSource)
  }
  searchInput = (e) => {
    this.setState({ searchText: e.target.value });
    this.gridApi.purgeInfiniteCache();
    // this.gridApi.refreshInfiniteCache();
  }
  refreshGrid = () => {
    this.gridApi.refreshInfiniteCache();
  }
  async viewOrder(event) {
    //await this.props.editClientData(event);
    this.setState({ showSideBar: true, selectedRowData: event, isEdit: true });
  }
  closeSidebar = () => {
    this.setState({ showSideBar: false, isEdit: false, selectedRowData: "" });
    this.refreshGrid();
  }
  AddOrder = () => {
    this.setState({ showSideBar: true });
  }
  render() {
    const { loading, showSideBar } = this.state;
    return (
      <>
        <div className="table-header d-flex align-items-center justify-content-between">
          <button className="add_order" onClick={this.AddOrder}><img src={AddIcon} /> Add </button>
        </div>
        <div className="shadow_white_box full-box mt-0">
          <div className="filter-list d-flex align-items-center justify-content-between">
            <div className="filter-field d-flex">
              <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
            </div>
          </div>
          <div className="clients_grid">
            <Grid
              columnDefs={this.state.columnDefs}
              rowModelType='infinite'
              onGridReady={this.onGridReady}
              height='600px'
            >
            </Grid>
          </div>
        </div>
        {/* {isShow && (<EditUser isShow={this.state.isShow} closeSidebar={this.closeSidebar} purchaseData={this.state.selectedRowData} />)} */}
        {showSideBar && (<AddOrder showSideBar={showSideBar} closeSidebar={this.closeSidebar} isEdit={this.state.isEdit} orderData={this.state.selectedRowData} />)}
      </>
    )
  }
}
const mapStateToProps = ({ UserReducer, PurchaseOrderReducer, InventoryItemsReducer }) => {
  let { UNRECORDED_ORDERS, PURCHASE_ORDERS } = PurchaseOrderReducer;
  let { CLOCKS_BILLING_ITEMS, ADD_INVENTORY_ITEMS } = InventoryItemsReducer;
  return { UserReducer, UNRECORDED_ORDERS, PURCHASE_ORDERS, CLOCKS_BILLING_ITEMS, ADD_INVENTORY_ITEMS };
};
export default connect(mapStateToProps, {
  getPurchaseOrders,
  unrecordedOrders,
  billingItemsClocks
})(PurchaseOrdersView);